// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteModulesEditEmpty_wrapper__kt4g6","text":"SiteModulesEditEmpty_text__5wshV"};